import { CustomChipProps, TmdxChip } from '@ds';
import { ResourceLogisticsStatus } from '@/api/apis/case';
import { CCShiftType, CSShiftType, SShiftType } from '@/api/apis/resources/schedule';
import { OcsConsoleStatus } from '@/api/apis/resources';

export type ChipWithStatusProps = Omit<CustomChipProps, 'dotStyles'> & {
  status?: ResourceLogisticsStatus | CSShiftType | SShiftType | CCShiftType | OcsConsoleStatus;
};

const statusDotStyles: { [key in ResourceLogisticsStatus | CSShiftType | SShiftType | CCShiftType]?: string } = {
  [ResourceLogisticsStatus.Reserved]: 'bg-base-50',
  [ResourceLogisticsStatus.BookingSent]: 'bg-aquamarine-10',
  [ResourceLogisticsStatus.Booked]: 'bg-aquamarine-10',
  [ResourceLogisticsStatus.DeployedToDonorHospital]: 'bg-orange-10',
  [ResourceLogisticsStatus.AtDonorHospital]: 'bg-orange-10',
  [ResourceLogisticsStatus.DeployedToTX]: 'bg-maroon-10',
  [ResourceLogisticsStatus.AtTXCenter]: 'bg-maroon-10',
  [ResourceLogisticsStatus.DeployedToHub]: 'bg-orange-10',
  [ResourceLogisticsStatus.ReturningToBase]: 'bg-orange-10',
  [ResourceLogisticsStatus.Done]: 'bg-success-50',
  [ResourceLogisticsStatus.OnRest]: 'bg-warning-50',
  // CSShiftType
  [CSShiftType.OnCall]: 'bg-success-40',
  [CSShiftType.PhoneSupport]: 'bg-indigo-40',
  [CSShiftType.Vacation]: 'bg-warning-40/20',
  [CSShiftType.Sick]: 'bg-warning-40/20',
  [CSShiftType.AtHub]: 'bg-info-60',
  [CSShiftType.Unavailable]: 'bg-danger-40/20',
  [CSShiftType.NoCall]: 'bg-base-50',
  [CSShiftType.WeekendOff]: 'bg-base-50',
  [CSShiftType.TravelDay]: 'bg-base-50',
  [CSShiftType.OfficeDay]: 'bg-success-40',
};

export const ChipWithStatus = ({ status, ...props }: ChipWithStatusProps) => {
  const dotStyle = status && status !== ResourceLogisticsStatus.None ? statusDotStyles[status] : '';

  return <TmdxChip {...props} dotStyles={dotStyle} />;
};
